// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"FiltersModal_modalWrapper__3d_a-","modalContent":"FiltersModal_modalContent__3bcD9","title":"FiltersModal_title__GOye9","controls":"FiltersModal_controls__2Ta93"};